import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';

function VisaPrepAdditionalPersonalInfoStep1_2(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.RESIDENTIAL_ADDRESS_START_DATE}
        label="Residential start date"
        fullLabel={`When did you start living at your current permanent residential address?`}
        value={props.residentialAddressStartDate}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HOME_OWNERSHIP_STATUS}
        label="Ownership status"
        fullLabel={`What is the ownership status of your home?`}
        value={props.homeOwnershipStatus}
      />
      {props.homeOwnershipStatus === 'Other' ? (
        <SummaryRow
          className={'visa-summary'}
          key={VQ.HOME_OWNERSHIP_STATUS}
          label="Ownership status (Other)"
          value={props.homeOwnershipStatusOther}
        />
      ) : null}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_DIFFERENT_CONTACT_DETAILS}
        label="Has different preferred contact details"
        fullLabel={`Are your preferred contact details different from the contact details already provided above?`}
        value={boolToYesNo(props.hasDifferentContactDetails)}
      />
      {props.hasDifferentContactDetails ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_ADDRESS}
            label="Contact address"
            value={props.diffContactAddress}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_CITY}
            label="City"
            value={props.diffContactCity}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_POSTCODE}
            label="Postcode"
            value={props.diffContactPostcode}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_COUNTRY}
            label="Country"
            value={props.diffContactCountry}
          />
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalPersonalInfoStep1_2;
